<template>

  <div>
    <div
      class="buymodal-block__body">

      <div
        class="body-info">
        <div
          class="body-info__title">
          Данные об устройстве
        </div>
        <div
          class="body-info__block">
          <div
            class="info-table">
            <div
              class="info-table__line">
              <div
                class="label">
                IMEI
              </div>
              <div
                class="value">
                {{ model.imei }}
              </div>
            </div>
            <div
              class="info-table__line"
              v-for="(item, i) in model.mobile" :key="i"
              v-if="arrayName.find(item => item.key === i)">
              <div
                class="label">
                {{ arrayName.find(item => item.key === i).name }}
              </div>
              <div
                class="value">
                {{ item }}
                
                <span v-if="i === 'model'"> (Устройство не найдено в прайсе, можно выкупить по минимальной цене)</span>
              </div>
            </div>
          </div>
          <div
            v-if="model.mobile.img && model.mobile.img != ''"
            class="info-image">
            <div
              class="info-image__img"
              v-html="model.mobile.img">
            </div>
            <!-- <button
              type="button"
              class="btn disagree"
              @click.prevent="$emit('badmodel')">
              Модель определена неверно
            </button> -->
          </div>
        </div>
        <!-- <div
          v-if="!model.mobile.img || model.mobile.img == ''"
          class="body-info__btn">
          <button
            type="button"
            class="btn disagree"
            @click.prevent="$emit('badmodel')">
            Модель определена неверно
          </button>
        </div> -->
      </div>

    </div>

    <div
      class="buymodal-block__footer">
      <button
        type="button"
        class="btn cancel"
        @click.prevent="$emit('leave')">
        Отказаться
      </button>
      <button
        type="button"
        class="btn next"
        @click.prevent="$emit('next')">
        Продолжить
      </button>
    </div>

  </div>

</template>

<script>
export default {
  props: ['model'],
  data() {
    return {
      arrayName: [
        { key: 'IMEI', name: 'IMEI' },
        // { key: 'SerialNumber', name: 'Серийный номер' },
        { key: 'ModelName', name: 'Модель' },
        { key: 'Capacity', name: 'Объем' },
        // { key: 'Color', name: 'Цвет' },
        { key: 'manufactorer', name: 'Производитель' },
        { key: 'model', name: 'Модель' },
      ]
    }
  }
}
</script>

<style lang="css">
</style>
